import React from 'react';
import { Routes, Route } from 'react-router-dom';
import FreezerPage from './FreezerPage';

/** Pages under /casa/congelador (adding and changing a batch are dialogs). */
const FreezerRoutes: React.FC = () => (
  <Routes>
    <Route index element={<FreezerPage />} />
  </Routes>
);

export default FreezerRoutes;
